'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var fetchArticle = exports.fetchArticle = function fetchArticle(query, setState) {
	return v12.article.get(query).then(function (response) {
		return setState({ article: response });
	});
};

var getSKUKey = exports.getSKUKey = function getSKUKey(sku) {
	return sku.attr1_id + '_' + sku.attr2_id + '_' + sku.attr3_id;
};

var cellIsHidden = function cellIsHidden(key, props) {
	var currentBreakpoint = props.breakpoint.breakpointOverride || props.breakpoint.breakpoint;

	switch (currentBreakpoint) {
		case 'md':
			{
				return props['tabletSize_' + key] === 'hidden';
			}
		case 'lg':
		case 'xlg':
			{
				return props['desktopSize_' + key] === 'hidden';
			}
		case 'xsm':
		case 'sm':
		default:
			{
				return props['mobileSize_' + key] === 'hidden';
			}
	}
};

var getHeadings = exports.getHeadings = function getHeadings(fields, props) {
	return fields.reduce(function (acc, key) {
		if (!props[key + 'Show'] || cellIsHidden(key, props)) {
			return acc;
		}

		if (key === 'qty' && !props.isBuyable) {
			return acc;
		}

		if (key === 'price' && !props.isBuyable && !props.alwaysShowPrice) {
			return acc;
		}

		return [].concat(_toConsumableArray(acc), [{
			key: key,
			value: props[key + 'Heading'],
			sort: parseInt(props[key + 'Sort'], 10),
			align: props[key + 'Align'],
			sizes: {
				mobile: props['mobileSize_' + key],
				tablet: props['tabletSize_' + key],
				desktop: props['desktopSize_' + key]
			}
		}]);
	}, []).sort(function (a, b) {
		return a.sort > b.sort ? 1 : -1;
	});
};

// Return media in the most specific order based on the SKU
var getMedia = function getMedia(article, sku) {
	var medias1 = v12.article.medias(article, { sku: sku, include: [1010], size: '' });

	if (medias1.length > 0) {
		return medias1[0].filename;
	}

	var medias2 = v12.article.medias(article, { sku: { attr1_id: sku.attr1_id, attr2_id: sku.attr2_id }, include: [1010], size: '' });

	if (medias2.length > 0) {
		return medias2[0].filename;
	}

	var medias3 = v12.article.medias(article, { sku: { attr1_id: sku.attr1_id }, include: [1010], size: '' });

	if (medias3.length > 0) {
		return medias3[0].filename;
	}

	var medias4 = v12.article.medias(article, { include: [1010], size: '' });

	if (medias4.length > 0) {
		return medias4[0].filename;
	}

	return '';
};

var getCellValue = function getCellValue(key, article, sku, props) {
	switch (key) {
		case 'artno':
			{
				return article.art_no;
			}
		case 'artname':
			{
				return article.artname;
			}
		case 'ean13':
			{
				return sku.ean13;
			}
		case 'pluno':
			{
				return sku.pluno;
			}
		case 'attr1':
			{
				return sku.attribute1.attr1_code;
			}
		case 'attr2':
			{
				return sku.attribute2.attr2_code;
			}
		case 'attr3':
			{
				return sku.attribute3.attr3_code;
			}
		case 'media':
			{
				return getMedia(article, sku);
			}
		case 'price':
			{
				return props.getPrice(sku.articlePrice.price_sales, sku.articlePrice.price_sales_exvat);
			}
		default:
			{
				return '';
			}
	}
};

var getCellData = exports.getCellData = function getCellData(fields, article, sku, props) {
	return fields.reduce(function (acc, key) {
		if (!props[key + 'Show'] || cellIsHidden(key, props)) {
			return acc;
		}

		if (key === 'qty' && !props.isBuyable) {
			return acc;
		}

		if (key === 'price' && !props.isBuyable && !props.alwaysShowPrice) {
			return acc;
		}

		return [].concat(_toConsumableArray(acc), [{
			key: key,
			value: getCellValue(key, article, sku, props),
			sort: parseInt(props[key + 'Sort'], 10),
			align: props[key + 'Align'],
			sizes: {
				mobile: props['mobileSize_' + key],
				tablet: props['tabletSize_' + key],
				desktop: props['desktopSize_' + key]
			}
		}]);
	}, []).sort(function (a, b) {
		return a.sort > b.sort ? 1 : -1;
	});
};